<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn_140">
      <el-select
        class="select_btn_style"
        v-model="filters.leaderType"
        placeholder="可审核管理主体"
      >
        <el-option
          v-for="(item, i) in leaderTypeData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.name"
        placeholder="审核人姓名"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" :title="'查询'" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";
import { getEnums } from "../../../../utils/common";
export default {
  components: {
    butn,
  },
  data() {
    return {
      filters: {
        name: '',
      },
      leaderTypeData: []
    };
  },
  created() {
    getEnums(["USER_LEADER_TYPE"],this,["leaderTypeData"],[true])
  },
  methods: {
    initData() {
      this.$emit("search", { ...this.filters });
    },
    resetData() {
      this.filters = {
        name: ''
      };
      this.$emit("search", { ...this.filters });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-select__tags {
  overflow: hidden;
  span {
    display: flex;
  }
}
</style>
